/**
 * AuditLogService
 * Service for AuditLog entity operations
 * Route: api/auditlog
 * Controller: AuditLogController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * AuditLogService
 * Handles audit log CRUD operations
 * Maps to /api/auditlog endpoint
 */
export class AuditLogService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AuditLogService.DEFAULT_SERVICE_PATH,
            basePath: AuditLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAllViewModels() {
        const response = await this.http.get(this.buildUrl('view-models'));
        return response.data ?? [];
    }
}
AuditLogService.DEFAULT_SERVICE_PATH = 'procurements';
AuditLogService.BASE_PATH = 'api/auditlog';
//# sourceMappingURL=AuditLogService.js.map